if($(".cal_campeonatos").length>0) {

    var inscripcion = {
        anadirTramo:function(){
            var dia = $(this).closest('.dia');
            var horasContainer = $(dia).find('.horasContainer');
            $(horasContainer).append($(".horasContainerOriginal").html());
            inscripcion.preparaTramoFormulario();
        },
        eliminarTramo:function(){
            var horas = $(this).closest('.horas');
            $(horas).remove();
            inscripcion.preparaTramoFormulario();
        },
        marcarTodo:function(){
            //Especifica al menos un tramo para cada dia
            $(".dia").each(function (k, dia) {
               if ($(dia).find('.horas').length==0){
                   var horasContainer = $(dia).find('.horasContainer');
                   $(horasContainer).append($(".horasContainerOriginal").html());
               }
            });
            inscripcion.preparaTramoFormulario();
        },
        preparaTramoFormulario:function(){
            $(".dia").each(function (k, dia) {
                var horasContainer = $(dia).find('.horasContainer');
                var fecha = $(dia).data('fecha');
                $(dia).find('.horasContainer .horas').each(function (k, horas) {
                    var preferenciaHoraria_hora_ini = $(horas).find('[data-name=preferenciaHoraria_hora_ini]');
                    $(preferenciaHoraria_hora_ini).attr('name', 'preferenciaHoraria[' + fecha + '][' + k + '][hora_ini]');
                    var preferenciaHoraria_hora_fin = $(horas).find('[data-name=preferenciaHoraria_hora_fin]');
                    $(preferenciaHoraria_hora_fin).attr('name', 'preferenciaHoraria[' + fecha + '][' + k + '][hora_fin]');
                });
            });
        },
        entre_clubs:{
            vue:null,
            newVue:function(id_reg_campeonatos_grupo,editarInscripcion,id_reg_equipos){
                inscripcion.entre_clubs.vue = new Vue({
                    el:"#entre_clubs_modal",
                    data:{
                        is_admin:null,
                        editarInscripcion:editarInscripcion,
                        id_reg_equipos:id_reg_equipos,
                        id_grup:id_reg_campeonatos_grupo,//id_reg_campeonatos_grupo
                        id_reg_campeonato: 0,
                        entre_clubs:1,
                        inscrits:'',
                        socios:[],
                        selected_socio:{value:0},
                        messageError:false,
                        messageSuccess:false,
                        participantes:[],
                        nombre_equipo:'',
                        capitan:{
                            nombre:'',
                            apellidos:'',
                            telefono:'',
                            email:''
                        },
                        subcapitan:{
                            nombre:'',
                            apellidos:'',
                            telefono:'',
                            email:''
                        },
                        generos:[],
                        eliminar_participantes_existentes:false
                    },
                    methods:{
                        participanteMoveUp:function(key,element){
                            var self = this;
                            if (key==0)
                                return;
                            self.participantes = array_move(self.participantes,key,key-1);
                        },
                        participanteMoveDown:function(key,element){
                            var self = this;
                            if (key==self.participantes.length-1)
                                return;
                            self.participantes = array_move(self.participantes,key,key+1);
                        },
                        anadirParticipante:function(){
                            var self = this;
                            var participante = {
                                nombre:'',
                                apellidos:'',
                                puntos_federado:'',
                                id_mst_genero: 2,
                            }
                            self.participantes.push(participante);
                        },
                        eliminaParticipante:function(index,event){
                            var self = this;
                            self.messageError = false;
                            self.messageSuccess = false;
                            //No es pot eliminar participant si aquest ja ha jugat algun partit, ho comprobem.

                            if (self.editarInscripcion && self.participantes[index]!=='undefined' && self.participantes[index].id_reg_inscritos_jugadores>0){
                                axios.get('/api/entreClubs/editarInscripcion/eliminaParticipante',{params:{
                                    id_reg_inscritos_jugadores:self.participantes[index].id_reg_inscritos_jugadores
                                }}).then(function(res){
                                   if(res.data.status==0){
                                       $(event.target).notify(
                                           Lang.get(res.data.msg),
                                           {position: "left", className: 'error'}
                                       );
                                   }else{
                                       self.$delete(self.participantes,index);
                                   }
                                });
                            }else{
                                self.$delete(self.participantes,index);
                            }

                        },
                        submitForm:function(){
                            var self = this;
                            self.messageError = false;
                            self.messageSuccess = false;
                            self.inscrits = [{observations:$('.observations_textarea').val()}];

                            if(self.editarInscripcion){
                                //Editamos inscripcion
                                axios.post('/api/entreClubs/editarInscripcion',
                                    self.$data
                                ).then(function(res){
                                    if (res.data.status==0)
                                        self.messageError = res.data.msg;
                                    else{
                                        self.messageSuccess = res.data.msg;
                                        if (!self.is_admin){
                                            var miss = Lang.get('inscripcion.ENTRECLUBSDATOSINSCRIPCIONINFO').toString();
                                            alert(miss.replace("{0}",res.data.organitzador));
                                        }
                                        setTimeout(function(){ location.reload() }, 3000);
                                    }
                                });
                            }else{
                                //Nueva inscripcion
                                axios.post('/sportssuite/manager.php?op=add_championship',
                                    self.$data
                                ).then(function(res){
                                    if (res.data.status=='fail')
                                        self.messageError = res.data.data.msg;
                                    else{
                                        self.messageSuccess = res.data.data.msg;
                                        if (!self.is_admin){
                                            var miss = Lang.get('inscripcion.ENTRECLUBSDATOSINSCRIPCIONINFO').toString();
                                            alert(miss.replace("{0}",res.data.organitzador));
                                        }
                                        setTimeout(function(){ location.reload() }, 3000);
                                    }
                                });
                            }
                        },
                        searchComunityUser:function(key){
                            var self = this;
                            var numero, letra, trobat, buscar_dni;
                            var expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
                            var dni =  $("#nif_campeonato_"+key).val();
                            dni = dni.toUpperCase();

                            if(expresion_regular_dni.test(dni) === true || dni.length > 7){
                                    axios.get('/api/entreClubs/inscripcion/comprobarUsuarioComunidad',
                                    {
                                        params: {
                                                nif: dni,
                                                id_grup: self.id_grup,
                                                id_reg_campeonato:  self.id_reg_campeonato,
                                                id_reg_equipos: self.id_reg_equipos,
                                                num_inscrito: key
                                        }
                                    }
                                    ).then(function(res){
                                        var alert = document.getElementById("alert_existe_"+key);
                                        var alert2 = document.getElementById("alert_existe_mobile_"+key);
                                        if (alert){
                                            alert.parentNode.removeChild(alert);
                                        }
                                        if (alert2){
                                            alert2.parentNode.removeChild(alert2);
                                        }
                                        if (res.data.status == '1'){
                                            $("#nif_campeonato_"+ key).css('border', '');
                                            $("#nif_campeonato_"+ key).css('border-radius', '');
                                            $("#nif_campeonato_m_"+ key).css('border', '');
                                            $("#nif_campeonato_m_"+ key).css('border-radius', '');

                                            self.participantes[key].nombre = res.data.nombre.toUpperCase();
                                            self.participantes[key].apellidos = res.data.apellidos.toUpperCase();
                                            var now_formatted = new moment();
                                            now_formatted = now_formatted.format('YYYY-MM-DD');
                                            if (res.data.fecha_nac !== null && res.data.fecha_nac !== undefined && res.data.fecha_nac !== '0000-00-00 00:00:00') self.participantes[key].fecha_nac = res.data.fecha_nac.split(" ")[0]; else self.participantes[key].fecha_nac = now_formatted;
                                            self.participantes[key].nif = res.data.nif.toUpperCase();
                                        }else if(res.data.status == '2'){
                                            var row = document.getElementById("inscritos_campeonato");
                                            var row2 = document.getElementById("inscritos_campeonato_responsive");
                                            var div = document.createElement("div");
                                            var div2 = document.createElement("div");
                                            div.innerHTML = Lang.get('msg.USUARIO_EXISTE_CAMPEONATO_GRUPO') + " " + res.data.nombre.toUpperCase() + ' ' + res.data.apellidos.toUpperCase() + " - " + res.data.equipo.toUpperCase();
                                            div.classList.add("alert");
                                            div.classList.add("alert-danger");
                                            div.style.width = "90%";
                                            div.style.margin = "auto";
                                            div.style.marginTop = "5px";
                                            div.id = "alert_existe_"+key;
                                            div2.innerHTML = Lang.get('msg.USUARIO_EXISTE_CAMPEONATO_GRUPO') + " " + res.data.nombre.toUpperCase() + ' ' + res.data.apellidos.toUpperCase() + " - " + res.data.equipo.toUpperCase();
                                            div2.classList.add("alert");
                                            div2.classList.add("alert-danger");
                                            div2.style.width = "90%";
                                            div2.style.margin = "auto";
                                            div2.style.marginTop = "5px";
                                            div2.id = "alert_existe_mobile_"+key;
                                            row.appendChild(div);
                                            row2.appendChild(div2);

                                            self.participantes[key].nombre = " ";
                                            self.participantes[key].apellidos = " ";
                                            self.participantes[key].fecha_nac = " ";

                                            return false;
                                        }else{
                                            $("#nif_campeonato_"+ key).css('border', '2px solid red');
                                            $("#nif_campeonato_"+ key).css('border-radius', '4px');
                                            $("#nif_campeonato_m_"+ key).css('border', '2px solid red');
                                            $("#nif_campeonato_m_"+ key).css('border-radius', '4px');

                                            self.participantes[key].nombre = " ";
                                            self.participantes[key].apellidos = " ";
                                            self.participantes[key].fecha_nac = " ";

                                            return false;
                                        }

                                });
                                return true;

                            }else{
                                $("#nif_campeonato_"+ key).css('border', '2px solid red');
                                $("#nif_campeonato_"+ key).css('border-radius', '4px');
                                $("#nif_campeonato_m_"+ key).css('border', '2px solid red');
                                $("#nif_campeonato_m_"+ key).css('border-radius', '4px');

                                self.participantes[key].nombre = " ";
                                self.participantes[key].apellidos = " ";
                                self.participantes[key].fecha_nac = " ";

                                return false;
                            }
                        }
                    },
                    beforeMount:function(){
                        var self = this;
                        $("#add_championship_form :submit").html(Lang.get('msg.desar_canvis'));
                        axios.get('/api/entreClubs/inscripcion/modal/data',{params: {
                            editarInscripcion:self.editarInscripcion,
                            id_reg_equipos:id_reg_equipos
                        }}).then(function(res){
                            self.is_admin = res.data.is_admin;
                            self.socios = res.data.socios;
                            if (self.editarInscripcion){
                                self.selected_socio = res.data.selected_socio;
                                self.participantes = res.data.participantes;
                                self.generos = res.data.generos;
                                self.nombre_equipo = res.data.nombre_equipo;
                                self.capitan = res.data.capitan;
                                self.subcapitan = res.data.subcapitan;
                                self.eliminar_participantes_existentes = res.data.eliminar_participantes_existentes;
                                self.is_admin=res.data.is_admin;
                                self.observaciones=res.data.observaciones;
                                $('.observations_textarea').val(res.data.observaciones);
                            }else{
                                //Inscripcio nova
                                self.nombre_equipo = res.data.nombre_equipo;
                            }
                            self.id_reg_campeonato = res.data.id_reg_campeonato;
                        });
                    }
                });
            },
            editarInscripcion: function(id_reg_equipos,id_reg_campeonatos_grupo,soloLectura){
                soloLectura = soloLectura || false;
                axios.get("/api/reserves/lst_campeonatos/modal/inscripcion/" + id_reg_campeonatos_grupo,{params:{
                    'editarInscripcion':true,
                    'id_reg_equipos':id_reg_equipos,
                    'soloLectura': soloLectura
                }}).then(function(res){
                    modal_c(res.data);
                });
            }
        },

        buscar_jugador:{
            selected: {},
            $table:null,
            $body:null,
            $i:null,
            $message:'',
            socios:[],
            onKeyUp:function(){

                $('.table-socis-campeonato table').addClass("hidden");

                $(document).on('keyup','.table-socis-campeonato .search',function(){
                    var search = $(this).val();

                    inscripcion.buscar_jugador.$message = $(this).closest(".table-socis-campeonato").find("div.message");
                    inscripcion.buscar_jugador.$i = $(this).closest(".table-socis-campeonato").find("div.message").attr("data-isocio");
                    inscripcion.buscar_jugador.$table = $(this).closest(".table-socis-campeonato").find("table");
                    inscripcion.buscar_jugador.$body = $(this).closest(".table-socis-campeonato").find("table > tbody");

                    if (search.length > 2) {
                        setTimeout(function () {
                            inscripcion.buscar_jugador.refresh(search);
                        }, 200);
                    }
                });

            },
            refresh:function(search, id){
                if (typeof(inscripcion.buscar_jugador.xhr)!=='undefined') {
                    inscripcion.buscar_jugador.xhr.abort();
                }

                inscripcion.buscar_jugador.xhr = $.ajax({
                    type: 'GET',
                    url: '../sportssuite/manager.php',
                    data: {
                        op: 'get_user_list',
                        name: search
                    }
                }).done(function (response) {
                    inscripcion.buscar_jugador.socios = response.data.socios;
                    inscripcion.buscar_jugador.render_table(search, id);
                });
            },
          render_table:function(search, id){

              if (id != undefined && id >= 0){
                  inscripcion.buscar_jugador.$message = $('#inscrito' + id).find("div.message");
                  inscripcion.buscar_jugador.$i = $('#inscrito' + id).find("div.message").attr("data-isocio");
                  inscripcion.buscar_jugador.$table = $('#inscrito' + id).find("table");
                  inscripcion.buscar_jugador.$body = $('#inscrito' + id).find("table > tbody");
              }

              inscripcion.buscar_jugador.$body.html('');
              var hg = new RegExp(search, "gi");
              var socios_ = inscripcion.buscar_jugador.socios;
              var $body_ = inscripcion.buscar_jugador.$body;

              if (socios_ == null || socios_ == undefined) {
                  return;
              }
              var checked = '';
              if (socios_.length === 1){
                  checked = 'checked';
              }
              if (socios_.length === 0) {
                  inscripcion.buscar_jugador.$table.addClass('hidden');
                  inscripcion.buscar_jugador.$message.html('<div class="alert alert-warning">'+Lang.get('msg.sense_resultats')+'</div>');
              } else {
                  inscripcion.buscar_jugador.$message.empty();
                  inscripcion.buscar_jugador.$table.removeClass('hidden');
              }

              var thead = false;

              socios_.forEach(function (e, i) {
                  var $row = $('<tr>').appendTo($body_),
                      $check_cell = $('<td>').appendTo($row),
                      $check = $('<input>').appendTo($check_cell);

                  $check.attr('type', 'radio');
                  $check.attr('name', 'inscrits[' + inscripcion.buscar_jugador.$i + '][socio]');
                  $check.attr('value', e.id);

                  if (checked === 'checked'){
                      $check.attr('checked', checked);
                  }
                  //if (typeof selected[e.id] !== 'undefined') {
                  //    $row.addClass('selected');
                  //    $check.attr('checked', true);
                  //}
                  //
                  //$check.change(function () {
                  //    var parent_tr = $(this).closest('tr');
                  //    parent_tr.removeClass('selected disabled_');
                  //    parent_tr.addClass('selected');
                  //    parent_tr.siblings().removeClass('selected disabled_');
                  //    parent_tr.siblings().addClass('hidden');
                  //});

                  $('<td>').appendTo($row).html(e.n.replace(hg, '<strong>' + search + '</strong>'));
                  $('<td>').appendTo($row).html(e.nivel);
              });
          }
        }

    }

    $(document).on('submit','#add_championship_form.entreClubs',function(e){
        e.preventDefault();
        inscripcion.entre_clubs.vue.submitForm();
        return false;
    });


    inscripcion.buscar_jugador.onKeyUp();

    $(document).on('click', '.preferenciaHoraria .anadirTramo',inscripcion.anadirTramo);
    $(document).on('click', '.preferenciaHoraria .eliminarTramo', inscripcion.eliminarTramo);
    $(document).on('click', '.preferenciaHoraria .marcarTodo', inscripcion.marcarTodo);

    $(document).on('keyup','.emailInput',function(){
        var this_ = $(this);
        var res = this_.val().split("@");
        res = slugify(res[0]);
        this_.closest('.soci_nou').find(".numsocioInput").val(res);
    });
}




